import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import PurchaseRequests from "@/pages/PurchaseRequests";
import PurchaseRequestNew from "@/pages/PurchaseRequestNew";
import PurchaseRequestDetail from "@/pages/PurchaseRequestDetail";
import Approvals from "@/pages/Approvals";
import PurchaseOrders from "@/pages/PurchaseOrders";
import Invoices from "@/pages/Invoices";
import InvoiceDetail from "@/pages/InvoiceDetail";
import ReviewEmailInvoices from "@/pages/ReviewEmailInvoices";
import Help from "@/pages/Help";
import ApprovalRules from "@/pages/ApprovalRules";
import Billing from "@/pages/Billing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import SuperAdmin from "@/pages/SuperAdmin";
import LoginAdmin from "@/pages/LoginAdmin";
import Releases from "@/pages/Releases";
import Versions from "@/pages/Versions";
import SchoolSettings from "@/pages/SchoolSettings";
import Signup from "@/pages/Signup";
import Privacy from "@/pages/Privacy";
import ResetPassword from "@/pages/ResetPassword";
import { hasRole } from "@/lib/format";

function RoleHome() {
    const { user } = useAuth();
    if (hasRole(user, "platform_admin")) return <Navigate to="/app/admin" replace />;
    return <Dashboard />;
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/login/admin" element={<LoginAdmin />} />
                        <Route path="/signup" element={<Signup />} />
                        <Route path="/releases" element={<Releases />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
                        <Route path="/app" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                            <Route index element={<RoleHome />} />
                            <Route path="requests" element={<PurchaseRequests />} />
                            <Route path="requests/new" element={<PurchaseRequestNew />} />
                            <Route path="requests/:id" element={<PurchaseRequestDetail />} />
                            <Route path="approvals" element={<ProtectedRoute roles={["school_admin", "approver"]}><Approvals /></ProtectedRoute>} />
                            <Route path="orders" element={<PurchaseOrders />} />
                            <Route path="invoices" element={<ProtectedRoute roles={["school_admin", "purchasing_admin"]}><Invoices /></ProtectedRoute>} />
                            <Route path="invoices/:id" element={<ProtectedRoute roles={["school_admin", "purchasing_admin"]}><InvoiceDetail /></ProtectedRoute>} />
                            <Route path="email-invoices" element={<ProtectedRoute roles={["school_admin", "purchasing_admin"]}><ReviewEmailInvoices /></ProtectedRoute>} />
                            <Route path="help" element={<Help />} />
                            <Route path="rules" element={<ProtectedRoute roles={["school_admin"]}><ApprovalRules /></ProtectedRoute>} />
                            <Route path="billing" element={<ProtectedRoute roles={["school_admin"]}><Billing /></ProtectedRoute>} />
                            <Route path="settings" element={<ProtectedRoute roles={["school_admin", "purchasing_admin"]}><SchoolSettings /></ProtectedRoute>} />
                            <Route path="admin" element={<ProtectedRoute roles={["platform_admin"]}><SuperAdmin /></ProtectedRoute>} />
                            <Route path="admin/versions" element={<ProtectedRoute roles={["platform_admin"]}><Versions /></ProtectedRoute>} />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                    <Toaster position="top-right" richColors />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
